import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    balance: 0,
    userInfo: {},
    securityToken: undefined,
    countries: [],
    quickLoginAuthInfo: undefined,
    statusBarHeight: 0,
    isMirroring: false
  },
  mutations: {
    setBalance(state, amount) {
      state.balance = amount
    },
    setUserInfo(state, info) {
      state.userInfo = info
    },
    delUserInfo(state) {
      state.userInfo = {}
    },
    clearState(state) {
      state.balance = undefined
      state.userInfo = undefined
      state.countries = []
    },
    delSecurityToken(state) {
      state.securityToken = undefined
    },
    setSecurityToken(state, value) {
      state.securityToken = value
    },
    setCountries(state, value) {
      state.countries = value
    },
    setQuickLoginAuthInfo(state, value) {
      state.quickLoginAuthInfo = value
    },
    delQuickLoginAuthInfo(state) {
      state.quickLoginAuthInfo = undefined
    },
    setStatusBarHeight(state, value) {
      state.statusBarHeight = value
    },
    delIsMirroring(state) {
      state.isMirroring = false
    },
    setIsMirroring(state, value) {
      state.isMirroring = value
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js